import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { Button, makeStyles } from "@material-ui/core";
import {
  Publish,
  Edit,
  Delete,
  CloudUpload,
  Add,
  Pause,
  PlayArrow,
  RotateLeft,
  ExpandMore,
  Sync,
  CancelOutlined,
  PlayCircleOutline,
  BarChart,
  Refresh,
  CloudDownload,
  SystemUpdateAlt,
  Settings,
  FileCopy,
  PersonAdd,
  AssignmentInd,
  Cancel,
} from "@material-ui/icons";
import styles from "./styles";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import AssignmentReturnIcon from "@material-ui/icons/AssignmentReturn";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  outlinedCancelButton: {
    minWidth: 100,
    whiteSpace: "nowrap",
    borderColor: theme.palette.error.main,
    color: theme.palette.error.main,
    "&:hover": {
      backgroundColor: theme.palette.error.light,
      borderColor: theme.palette.error.dark,
    },
  },
}));

export const AddButton = ({ className, size, ...props }) => {
  return (
    <Button
      style={{ minWidth: 100 }}
      className={className}
      size={size || "small"}
      color="primary"
      variant="contained"
      {...props}
    >
      <Add className="mr-1" fontSize="small" /> {props.label || "Button"}
    </Button>
  );
};

export const ResetButton = ({ className, size, ...props }) => {
  return (
    <Button
      style={{
        minWidth: 100,
        justifyContent: "space-around",
        backgroundColor: "primary",
      }}
      className={className}
      size={size || "small"}
      color="primary"
      variant="contained"
      {...props}
    >
      <RotateLeft className="mr-2" fontSize="small" /> {props.label || "Button"}
    </Button>
  );
};

export const PlayButton = ({ className, size, ...props }) => {
  return (
    <Button
      style={{ minWidth: 100, justifyContent: "space-between" }}
      className={className}
      size={size || "small"}
      color="primary"
      variant="contained"
      {...props}
    >
      <PlayArrow className="mr-2" fontSize="small" /> {props.label || "Button"}
    </Button>
  );
};

export const PauseButton = ({ className, size, ...props }) => {
  return (
    <Button
      style={{ minWidth: 100, justifyContent: "space-between" }}
      className={className}
      size={size || "small"}
      color="primary"
      variant="contained"
      {...props}
    >
      <Pause className="mr-2" fontSize="small" /> {props.label || "Button"}
    </Button>
  );
};

export const LoadButton = ({ className, size, ...props }) => {
  return (
    <Button
      style={{ minWidth: 100, justifyContent: "space-between" }}
      className={className}
      size={size || "small"}
      color="primary"
      variant="contained"
      {...props}
    >
      <ExpandMore className="mr-2" fontSize="small" /> {props.label || "Button"}
    </Button>
  );
};

export const Upgrade = ({
  className,
  size,
  variant = "contained",
  ...props
}) => {
  return (
    <Button
      style={{ minWidth: 100, whiteSpace: "nowrap" }}
      className={className}
      size={size || "small"}
      color="primary"
      variant={variant}
      {...props}
    >
      <Publish className="mr-2" fontSize="small" /> {props.label || "Button"}
    </Button>
  );
};

export const CancelButton = ({ className, size, ...props }) => {
  const classes = useStyles();

  return (
    <Button
      variant="outlined"
      className={`${classes.outlinedCancelButton} ${className || ""}`}
      size={size || "small"}
      {...props}
    >
      <Cancel style={{ marginRight: 8 }} fontSize="small" />
      {props.label || "Cancel"}
    </Button>
  );
};

export const UpgradeAll = ({ className, size, ...props }) => {
  return (
    <Button
      style={{ minWidth: 150, whiteSpace: "nowrap" }}
      className={className}
      size={size || "small"}
      color="primary"
      variant="contained"
      {...props}
    >
      <Publish className="mr-2" fontSize="small" /> {props.label || "Button"}
    </Button>
  );
};

export const DeployButton = ({ className, size, ...props }) => {
  return (
    <Button
      style={{ minWidth: 100, whiteSpace: "nowrap" }}
      className={className}
      size={size || "small"}
      color="primary"
      variant="outlined"
      {...props}
    >
      <Sync className="mr-2" fontSize="small" /> {props.label || "Button"}
    </Button>
  );
};
export const ActiveButton = ({ className, size, ...props }) => {
  return (
    <Button
      style={{ minWidth: 100, whiteSpace: "nowrap" }}
      className={className}
      size={size || "small"}
      color="primary"
      variant="outlined"
      {...props}
    >
      <PlayCircleOutline className="mr-2" fontSize="small" />{" "}
      {props.label || "Button"}
    </Button>
  );
};
export const DeactiveButton = ({ className, size, ...props }) => {
  return (
    <Button
      style={{ minWidth: 100, whiteSpace: "nowrap" }}
      className={className}
      size={size || "small"}
      color="primary"
      variant="outlined"
      {...props}
    >
      <CancelOutlined className="mr-2" fontSize="small" />{" "}
      {props.label || "Button"}
    </Button>
  );
};

export const GraphButton = ({ className, size, ...props }) => {
  return (
    <Button
      style={{ minWidth: 100, whiteSpace: "nowrap" }}
      className={className}
      size={size || "small"}
      color="primary"
      variant="outlined"
      {...props}
    >
      <BarChart className="mr-2" fontSize="small" /> {props.label || "Button"}
    </Button>
  );
};

export const EditButton = ({ className, size, loading = false, ...props }) => {
  return (
    <Button
      style={{ minWidth: 100 }}
      className={classNames(className)}
      size={size || "small"}
      color="primary"
      variant="outlined"
      {...props}
    >
      <Edit className="mr-1" fontSize="small" /> {props.label || "Button"}{" "}
      &nbsp;
      {loading ? <CircularProgress color="inherit" size={20} /> : null}
    </Button>
  );
};

export const CloneButton = ({ className, size, ...props }) => {
  return (
    <Button
      style={{ minWidth: 100 }}
      className={classNames(className)}
      size={size || "small"}
      color="primary"
      variant="outlined"
      {...props}
    >
      <FileCopy className="mr-1" fontSize="small" /> {props.label || "Button"}
    </Button>
  );
};

export const AllocateButton = ({ className, size, ...props }) => {
  return (
    <Button
      style={{ minWidth: 100 }}
      className={classNames(className)}
      size={size || "small"}
      color="primary"
      variant="outlined"
      {...props}
    >
      <AssignmentTurnedInIcon className="mr-1" fontSize="small" />{" "}
      {props.label || "Button"}
    </Button>
  );
};

export const RefreshButton = ({
  className,
  size,
  cooldown,
  onClick,
  disabled,
  label,
  ...rest
}) => {
  const [isCooldown, setIsCooldown] = useState(false);

  const handleClick = (e) => {
    if (onClick) onClick(e);
    if (typeof cooldown === "number" && cooldown > 0) {
      setIsCooldown(true);
    }
  };

  useEffect(() => {
    if (isCooldown && typeof cooldown === "number" && cooldown > 0) {
      const timer = setTimeout(() => {
        setIsCooldown(false);
      }, cooldown);
      return () => clearTimeout(timer);
    }
  }, [isCooldown, cooldown]);

  return (
    <Button
      style={{ minWidth: 100 }}
      className={classNames(className)}
      size={size || "small"}
      color="primary"
      variant="outlined"
      onClick={handleClick}
      disabled={isCooldown || disabled}
      {...rest}
    >
      <Refresh className="mr-1" fontSize="small" />
      {label || "Button"}
    </Button>
  );
};

export const ExportButton = ({ className, size, ...props }) => {
  return (
    <Button
      style={{ minWidth: 100 }}
      className={className}
      size={size || "small"}
      color="primary"
      variant="contained"
      {...props}
    >
      <CloudDownload className="mr-1" fontSize="small" />{" "}
      {props.label || "Button"}
    </Button>
  );
};

export const StatusUpdateButton = ({ className, size, ...props }) => {
  return (
    <Button
      style={{ minWidth: 100 }}
      className={className}
      size={size || "small"}
      color="primary"
      variant="outlined"
      {...props}
    >
      <SystemUpdateAlt className="mr-1" fontSize="small" />{" "}
      {props.label || "Button"}
    </Button>
  );
};

export const UnAllocateButton = ({ className, size, ...props }) => {
  return (
    <Button
      style={{ minWidth: 100 }}
      className={classNames(className)}
      size={size || "small"}
      color="primary"
      variant="outlined"
      {...props}
    >
      <AssignmentReturnIcon className="mr-1" fontSize="small" />{" "}
      {props.label || "Button"}
    </Button>
  );
};

export const ButtonIcon = ({
  className,
  Icon,
  size,
  color = "primary",
  loading = false,
  ...props
}) => {
  return (
    <Button
      style={{ minWidth: 100 }}
      className={className}
      size={size || "small"}
      color={color}
      variant="contained"
      {...props}
    >
      {loading ? (
        <CircularProgress style={{ height: 20, width: 20 }} />
      ) : (
        <Icon className="mr-1" fontSize="small" />
      )}{" "}
      {props.label || "Button"}
    </Button>
  );
};

export const DeleteButton = ({ className, size, ...props }) => {
  const classes = styles();
  return (
    <Button
      style={{ minWidth: 100 }}
      className={classNames(className, classes.deleteButton)}
      size={size || "small"}
      variant="outlined"
      {...props}
    >
      <Delete className="mr-1" fontSize="small" /> {props.label || "Button"}
    </Button>
  );
};

export const LoginAsButton = ({
  className,
  size,
  loading = false,
  ...props
}) => {
  return (
    <Button
      style={{ minWidth: 100 }}
      className={classNames(className)}
      size={size || "small"}
      color="primary"
      variant="outlined"
      {...props}
    >
      <PersonAdd className="mr-1" fontSize="small" /> {props.label || "Button"}{" "}
      &nbsp;
      {loading ? <CircularProgress color="inherit" size={20} /> : null}
    </Button>
  );
};
export const DefaultUserButton = ({
  className,
  size,
  loading = false,
  disabled = false,
  ...props
}) => {
  return (
    <Button
      style={{ minWidth: 100 }}
      className={classNames(className)}
      disabled={disabled}
      size={size || "small"}
      color="primary"
      variant="outlined"
      {...props}
    >
      <AssignmentInd className="mr-1" fontSize="small" />{" "}
      {props.label || "Button"} &nbsp;
      {loading ? <CircularProgress color="inherit" size={20} /> : null}
    </Button>
  );
};
export const FileUploadButton = ({
  className,
  size,
  style = {},
  uploaded = false,
  disabled = false,
  accept = "",
  multiple = false,
  value,
  ...props
}) => {
  // const id = parseInt((new Date() * 1) + Math.random());
  const id = "_" + Math.random().toString(36).substr(2, 9);
  return (
    <>
      <Button
        disabled={disabled}
        style={{
          minWidth: 100,
          whiteSpace: "nowrap",
          width: "100%",
          maxWidth: 240,
          ...style,
        }}
        className={className}
        onClick={() => {
          document.getElementById(id).click();
        }}
        size={size || "small"}
        color="primary"
        variant="outlined"
      >
        {uploaded || value ? (
          <CheckCircleOutlineIcon className="mr-2" fontSize="small" />
        ) : (
          <CloudUpload className="mr-2" fontSize="small" />
        )}{" "}
        {props.label || "Button"}
      </Button>
      <input
        multiple={multiple}
        type="file"
        onChange={(e) => {
          props.onChange(e.target.files);
        }}
        onClick={(e) => (e.target.value = "")}
        id={id}
        style={{ position: "absolute", top: "-1000px" }}
        accept={accept}
      />
    </>
  );
};

export const ImportButton = ({ className, size, ...props }) => {
  return (
    <Button
      style={{ minWidth: 100 }}
      className={className}
      size={size || "small"}
      color="primary"
      variant="contained"
      {...props}
    >
      <CloudUpload className="mr-1" fontSize="small" />{" "}
      {props.label || "Button"}
    </Button>
  );
};

export const ApplyButton = ({ className, size, onClick, ...props }) => {
  return (
    <Button
      style={{ minWidth: 100 }}
      className={className}
      size={size || "small"}
      color="primary"
      variant="contained"
      onClick={onClick}
      {...props}
    >
      {props.label || "Apply"}
    </Button>
  );
};

export const SettingsButton = ({ className, size, ...props }) => {
  return (
    <Button
      style={{ minWidth: 100 }}
      className={className}
      size={size || "small"}
      color="primary"
      variant="contained"
      {...props}
    >
      <Settings className="mr-1" fontSize="small" /> {props.label || "Button"}
    </Button>
  );
};
